import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/landingPage.js";

// Sections for this page
import Section1 from "./Sections/Section1.js";
import Section2 from "./Sections/Section2.js";
import Section3 from "./Sections/Section3.js";

// const dashboardRoutes = [];
import { useWeb3React } from "@web3-react/core";

const useStyles = makeStyles(styles);

export default function LandingPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  let history = useHistory();

  const web3ReactAlwaysOn = useWeb3React("alwaysOn");

  function handleClick() {
    history.push("/treasure-list/" + web3ReactAlwaysOn.chainId);
  }

  function handleClickMyTreasures() {
    history.push("/my-treasures/" + web3ReactAlwaysOn.chainId);
  }

  return (
    <div>
      {/* <div style={{ backgroundColor: "brown", align: "center" }}>Beta</div> */}
      <Header
        color="transparent"
        brand="CryptoTreasures"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "primary",
        }}
        {...rest}
      />
      <Parallax filter image={require("assets/img/background.jpg").default}>
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={6} align="center">
              <h1
                className={classes.title}
                style={{ fontFamily: "MedievalSharp" }}
              >
                Crypto Treasures
              </h1>
              <h3 style={{ fontWeight: 600 }}>
                For giveaways, moving NFT collections, or storing your stash
                away
              </h3>
              <br />
              <Button color="warning" size="lg" onClick={handleClick}>
                View the treasures
              </Button>
              <Button
                color="warning"
                size="lg"
                onClick={handleClickMyTreasures}
              >
                View my treasures
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <Section1 />
        </div>

        <div className={classes.container}>
          <Section2 />
        </div>

        <div className={classes.container}>
          <Section3 />
        </div>
      </div>
      <Footer />
    </div>
  );
}
